module.exports = __webpack_public_path__ + "img/step6-07.e0cbce1f.jpg";